import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../theme';

export const useUserTemplateManagementStyles = createStyles(
  ({ css, token }) => {
    const templateName = css({
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 500,
      fontSize: 13,

      span: {
        fontSize: 10,
        fontWeight: 400,
        color: ThemeColors.COLOR_GREY_BLUISH,
        textTransform: 'uppercase',
      },
    });

    const editButton = css({
      color: ThemeColors.COLOR_RED,
      cursor: 'pointer',
    });

    const templateListItem = css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 20px',
      borderRadius: token.borderRadiusSM,
      marginBottom: 20,
      backgroundColor: ThemeColors.COLOR_WHITE,
      boxShadow: `1px 1px 6px 0 ${ThemeColors.COLOR_GREY8_1}`,
      cursor: 'pointer',

      '&:nth-child(even)': {
        backgroundColor: ThemeColors.COLOR_GREY10,
      },
    });

    const templateList = css({
      marginTop: 10,
      padding: '0 10px',
    });

    const templateListContainer = css({
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    });

    const templateListPagination = css({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 'auto',

      '.ant-pagination': {
        textAlign: 'center',
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '.ant-pagination-prev': {
          marginRight: 0,
        },

        '.ant-pagination-prev, .ant-pagination-next': {
          color: ThemeColors.COLOR_RED,
          height: 20,
          lineHeight: '20px',

          '> span': {
            fontSize: 20,
          },
        },

        '.ant-pagination-simple-pager': {
          fontSize: 0,
          marginRight: 0,
          display: 'inline-flex',
          alignItems: 'center',

          '> input': {
            fontSize: 12,
            fontWeight: 500,
            color: ThemeColors.COLOR_RED,
            marginRight: 5,
            borderRadius: 4,
            border: `0.5px solid ${ThemeColors.COLOR_GREY6}`,
            width: 30,
            height: 20,
          },

          '> span': {
            display: 'none',
          },

          '&::before, &::after': {
            fontSize: 12,
            fontWeight: 500,
            color: ThemeColors.COLOR_GREY_BLUISH,
            textTransform: 'uppercase',
            lineHeight: '20px',
          },

          '&::before': {
            content: 'var(--page-label)',
            marginRight: 5,
          },

          '&::after': {
            content: 'var(--out-of-label)',
          },
        },
      },
    });

    const templateManagementHeader = css({
      marginBottom: 10,
      alignItems: 'center',

      '.ant-col': {
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
      },

      '.InputSearchFlat': {
        borderRadius: 15,
        height: 24,
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        borderColor: ThemeColors.COLOR_GREY9_5,
        boxShadow: `1px 1px 3px 0 inset ${hexToRgbaWithAlpha('#768398', 0.85)}`,

        '.ant-input': {
          borderRadius: 0,
          margin: '3px 0',
        },
      },
    });

    return {
      drawer: {
        '&& > .ant-drawer-content-wrapper .ant-drawer-body': {
          padding: '10px 40px',
        },
      },
      templateManagementHeader,
      templateList,
      templateListItem,
      templateName,
      editButton,
      templateListContainer,
      templateListPagination,
    };
  }
);
